<woa-field #field [label]="label()" [link]="link()" [message]="message()" [translationParams]="translationParams()"
           [noMessage]="noMessage()" [showMessageSpinner]="showMessageSpinner()" [readOnly]="readOnly()" [disabled]="disabled()"
           (onActivateField)="activated()" (onActivateLink)="onActivateLink.emit()">
    <div class="selection-field-value" [class.empty]="valueSignal() == undefined">
        {{ optionDisplayValue() || (placeholder() | translate: translationParams()) }}
    </div>
    @if (!disabled() && !readOnly()) {
        <woa-toggle class="selection-field-toggle"
                    [active]="toggleActive() || (field.touchable()?.touched())"></woa-toggle>
    }
</woa-field>
